export default function getThumbnail(
  image: HTMLImageElement,
  coordinates: number[],
  size: [number, number] = [128, 128]
): string {
  // OL's Y axis is flipped compared to img's coordinates system
  const thumbCoord = [coordinates[0], -coordinates[1]]
  const canvas = document.createElement('canvas')
  canvas.width = size[0]
  canvas.height = size[1]
  const ctx = canvas.getContext('2d')
  if (ctx) {
    ctx.drawImage(
      image,
      thumbCoord[0] - size[0] / 2,
      thumbCoord[1] - size[1] / 2,
      size[0],
      size[1],
      0,
      0,
      size[0],
      size[1]
    )

    return canvas.toDataURL('image/jpeg')
  } else {
    throw new Error('Unable to get canvas 2d context')
  }
}
